import { render, staticRenderFns } from "./primary-info.vue?vue&type=template&id=9dd2e4ce&scoped=true&"
import script from "./primary-info.js?vue&type=script&lang=js&"
export * from "./primary-info.js?vue&type=script&lang=js&"
import style0 from "./primary-info.scss?vue&type=style&index=0&id=9dd2e4ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd2e4ce",
  null
  
)

export default component.exports